module.exports = __webpack_public_path__ + "static/img/fddx.ac23f6f7.png";